
import BlockMedia from 'components/BlockMedia';
import ComponentPlaceholder from 'components/ComponentPlaceholder';
import { LayoutContainer } from 'components/Layout';
import type { DigizuiteAsset } from 'models/asset';
import type { ProductCard as ProductCardType } from 'models/productCard';
import type { Field, SitecoreBlockProps } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';
import { cn } from 'utils/classNames';
import { getAsset } from 'utils/helpers';

interface Props extends SitecoreBlockProps {
	fields?: {
		datasourceName?: string;
		isWide?: Field<boolean>;
		landscapeImage?: Field<DigizuiteAsset[]>;
		products?: ProductCardType[];
	};
}

export default function MediaLandscape({ fields, params }: Props) {
	if (!fields) {
		return null;
	}

	const { datasourceName, landscapeImage, products } = fields;
	const isWide = Boolean(fields.isWide?.value);
	const landscapeImg = getAsset('Templated 2:1', landscapeImage);

	if (!landscapeImg) {
		return (
			<ComponentPlaceholder
				componentName="MediaLandscape"
				description="Requires an image"
				className={getEditorMargin(params)}
			/>
		);
	}

	return (
		<LayoutContainer
			id={params?.anchor}
			outerClassName={getEditorMargin(params)}
			withGrid
		>
			<div
				className={cn(
					'col-span-full',
					!isWide && 'md:col-span-6 md:col-start-4',
				)}
			>
				<BlockMedia
					image={{
						src: landscapeImg?.src,
						alt: landscapeImg?.alt,
						variant: 'landscape2x1Large',
					}}
					products={products}
					productsDisplayType="shopByMedia"
					gtmItemListId="block"
					gtmItemListName={`Block: ${datasourceName ?? 'MediaLandscapeUnknown'}`}
				/>
			</div>
		</LayoutContainer>
	);
}
MediaLandscape.displayName = 'MediaLandscape';
